import { memo } from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { HistoryOutlined } from "@mui/icons-material";
import theme from "themeProvider";

const badgeTextSx = {
  fontWeight: 700,
  letterSpacing: 0.3,
  textTransform: "uppercase",
  whiteSpace: "nowrap",
};

// Top row of a card: source icon + badges (source, cached, retry, latest).
const EventCardHeader = ({ Icon, color, eventSrc, fromCache, retry, isLatest }) => (
  <Box display="flex" alignItems="center" gap={1}>
    <Box
      sx={{
        width: 26,
        height: 26,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: alpha(color, 0.14),
        flexShrink: 0,
      }}
    >
      <Icon sx={{ fontSize: 14, color }} />
    </Box>
    {!!eventSrc && (
      <Box
        sx={{
          display: "inline-flex",
          px: 1,
          py: 0.25,
          borderRadius: 10,
          background: alpha(color, 0.12),
        }}
      >
        <Typography sx={{ ...badgeTextSx, fontSize: 10, color }}>
          {eventSrc}
        </Typography>
      </Box>
    )}
    {fromCache && (
      <Box
        title="Not live - showing the last events saved on this device"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.25,
          px: 0.75,
          py: 0.25,
          borderRadius: 10,
          background: theme.palette.grey[200],
          flexShrink: 0,
        }}
      >
        <HistoryOutlined
          sx={{ fontSize: 10, color: theme.palette.text.secondary }}
        />
        <Typography
          sx={{
            ...badgeTextSx,
            fontSize: 9,
            color: theme.palette.text.secondary,
          }}
        >
          Cached
        </Typography>
      </Box>
    )}
    {!!retry && (
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          color: theme.palette.warning.dark,
          whiteSpace: "nowrap",
          ml: isLatest ? 0 : "auto",
        }}
      >
        retry {retry}
      </Typography>
    )}
    {isLatest && (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          px: 0.75,
          py: 0.25,
          borderRadius: 10,
          background: color,
          ml: "auto",
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            width: 5,
            height: 5,
            borderRadius: "50%",
            background: theme.palette.common.white,
          }}
        />
        <Typography
          sx={{ ...badgeTextSx, fontSize: 9, color: theme.palette.common.white }}
        >
          Latest
        </Typography>
      </Box>
    )}
  </Box>
);

export default memo(EventCardHeader);
